/** Add the verified public listing URLs after each store has approved AutoDay. */
export const STORE_LINKS: { googlePlay: string | null; appStore: string | null } = {
  googlePlay: null,
  appStore: null,
};
